module.exports = "/_next/static/images/truck1-bffb940cf1d9e34643bd347f85ef3a1a.png.webp";